import { Box, Typography } from "@mui/material";
import DashboardOrderStatistics from "Components/Dashboard/DashboardOrderStatistics";
import FlashingCardsDashboard from "Components/Dashboard/FlashingCardsDashboard";
import DashboardBarchart from "Components/Dashboard/DashboardBarchart";
import { useRTL } from "hooks/isRTL";
import { useState } from "react";
import { OrderTypeEnum } from "enums/shared";

const DashboardPage = () => {
  const { t } = useRTL();
  const [selectedTypes, setSelectedTypes] = useState([]); // track the selected issue type from the DashboardOrderStatistics with the filtering in one place
  const [selectedOrderType, setSelectedOrderType] = useState(() => {
    try {
      const stored = localStorage.getItem("selectedOrderType");
      return stored !== null ? Number(stored) : OrderTypeEnum.regular;
    } catch (e) {
      return OrderTypeEnum.regular;
    }
  });

  const updateSelectedOrderType = (val) => {
    setSelectedOrderType(val);
    try {
      localStorage.setItem("selectedOrderType", String(val));
    } catch (e) {
      // ignore localStorage errors (e.g., private mode)
    }
  };

  const handleClearFilters = () => {
    setSelectedTypes([]);
  };

  // update the selected issue type when a card is clicked
  const handleCardClick = (issueType) => {
    setSelectedTypes((prevTypes) =>
      prevTypes.includes(issueType)
        ? prevTypes.filter((temp) => temp !== issueType) // remove type if already selected
        : [...prevTypes, issueType]
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        padding: "30px 30px 0px",
      }}
    >
      <Box sx={{ flex: 1, marginRight: "1rem" }}>
        <Typography variant="h1">{t("welcomeback")}</Typography>

        <DashboardOrderStatistics
          onCardClick={handleCardClick}
          selectedTypes={selectedTypes}
          onClearFilters={handleClearFilters}
          selectedOrderType={selectedOrderType}
          setSelectedOrderType={updateSelectedOrderType}
        />
        <Box>
          <DashboardBarchart orderType={selectedOrderType} />
        </Box>
      </Box>

      <FlashingCardsDashboard
        selectedTypes={selectedTypes}
        setSelectedTypes={setSelectedTypes}
        orderType={selectedOrderType}
      />
    </Box>
  );
};

export default DashboardPage;
